import type { ButtonProps } from '@chakra-ui/react';
import * as React from 'react';
import { LuX } from 'react-icons/lu';
import { IconButton } from '@/components/ui/icon-button';
import { ROUNDED_FOCUS_RING } from '@/components/ui/focusStyles.ts';

export type CloseButtonProps = ButtonProps;

export const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function CloseButton(props, ref) {
	return (
		<IconButton
			size="sm"
			variant="ghost"
			color="fg.muted"
			aria-label="Close"
			ref={ref}
			_focusVisible={ROUNDED_FOCUS_RING}
			{...props}
		>
			{props.children ?? <LuX />}
		</IconButton>
	);
});
